import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Avatar,
  Button,
  Grid,
  Icon,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import SignupForm from '../../../components/forms/SignupForm'


class PlanCreateAccount extends Component {
  constructor(props) {
    super(props)

    this.state = {
      contact: props.contact || null,
    }
  }

  handleSignin = (user) => {
    this.setState({contact: user})
    this.props.onSignin(user)
    this.props.onUpdated({contact: user})
  }

  removeUser = () => {
    this.setState({contact: null})
  }

  submitRequest = () => {
    this.props.onUpdated({contact: this.state.contact})
  }

  render() {
    const { user, classes } = this.props
    const { contact } = this.state

    return (
      <Fragment>
        {!this.state.contact ?
          <Grid item xs={12} sm={7} md={6} style={{maxWidth: 393}}>
            <SignupForm
              type={this.props.dialogType || 'signup'}
              onSignin={this.handleSignin}
              user={user}
              hideHeader={true}
            />
          </Grid>
        :
          <Fragment>
              <Grid item xs={12} sm={7} md={8} style={{margin: '0px auto'}}>
                <List className={classes.menu}>
                  <ListItem classes={{root: classes.listItemSelected}}>
                    <ListItemAvatar>
                      <Avatar alt="Profile" src={contact.image} style={{marginRight: -5}}/>
                    </ListItemAvatar>
                    <ListItemText
                      primary={contact.first_name}
                      secondary={contact.email}
                      classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}}
                    />
                    <ListItemSecondaryAction onClick={this.removeUser} classes={{root: classes.listItemTextRemove}}>
                      <Icon className="material-icons-outlined notranslate">close</Icon>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </Grid>

              <Grid item xs={12} sm={7} md={8} style={{margin: '0px auto'}}>
                <Button disabled={!(this.state.contact)} onClick={this.submitRequest} variant="contained" color="primary" size="large" className={classes.buttonBook}>
                  {this.props.isSubmitting ?
                    <Fragment>Sending...</Fragment>
                    :
                    <Fragment>Continue<Icon className="material-icons-outlined notranslate" style={{marginLeft: 10}}>east</Icon></Fragment>
                  }
                </Button>
              </Grid>
          </Fragment>
        }
      </Fragment>
    )
  }
}

const styles = theme => ({
  listItemIcon: {
    color: '#02c39a',
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextRemove: {
    lineHeight: 0,
    padding: 5,
    backgroundColor: '#eee',
    borderRadius: 25,
    cursor: 'pointer',
  },
  listItemSelected: {
    borderRadius: 15,
    border: '1px solid #02c39a',
    marginBottom: 5,
  },
  listItem: {
    borderRadius: 15,
    border: '1px solid transparent',
    marginBottom: 5,

    '&:hover': {
      backgroundColor: '#07c3991a',
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
})

export default withRouter(withStyles(styles)(PlanCreateAccount))
